import Vue from "vue";
import {
  Button,
  List,
  Dialog,
  Toast,
  Field,
  Notify,
  Overlay,
  Loading
} from "vant";

Vue.use(Button);
Vue.use(List);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Field);
Vue.use(Notify);
Vue.use(Overlay);
Vue.use(Loading);
Vue.prototype.$vantDialog = Dialog;
Vue.prototype.$vantNotify = Notify;
